<template>
  <div id="index">
    <div class="mIndexSearch">
      <img class="mLogo" src="../../assets/img/mLogo.png" />
      <input placeholder="搜索药材名称"  @click="goProductList" />
      <img class="mIndexSearchImg" src="../../assets/img/mIndexSearch.png" >
      <button @click="goLogin">登录</button>
    </div>


    <!-- <div class="mHeader">
      <img class="mHeaderLeft" src="../../assets/img/mLeft1.png" >
      <b>亳药师</b>
      <img class="mHeaderMenu" v-show="showHeaderIcon" src="../../assets/img/mIndexMenu.png" @click="showMenu">
      <img class="mHeaderUser" v-show="showHeaderIcon" src="../../assets/img/mUser.png"  @click="goLogin">
      <img class="mHeaderClose" v-show="showHeaderIcon2" src="../../assets/img/mIndexClose.png" @click="closeMenu" >
    </div>
    <div class="mMenu" v-show="showMenuDiv">
      <ul>
        <li v-for="(item,menuIndex) in menuList" :class="menuActiveClass == menuIndex ? 'menuActive':''" :key="item.name"  @click="goMenu(item.go,menuIndex)">{{item.name}}</li>
      </ul>
    </div> -->
     <div class="mFootTab">
      <ul>
        <li v-for="(item,menuIndex) in menuList" :class="menuActiveClass == menuIndex ? 'menuActive':''" :key="item.name"  @click="goMenu(item.go,menuIndex)">
          <img :src="item.Imgurl" :alt="item.name">
          <p>{{item.name}}</p>
        </li>
      </ul>
    </div>
    <!-- <mHeader ref="mHeader"></mHeader>  -->
    <div class="mBanner">
      <el-carousel indicator-position="none" :interval="5000" arrow="always" >
        <!-- <el-carousel-item v-for="item in bannerlist" :key="item.id" style="height:421px">
          <img :src="item.imageUrl" alt="">
        </el-carousel-item> -->
        <el-carousel-item style="height:421px">
          <img src="../../assets/img/bannerImg2.png">
        </el-carousel-item>
        <el-carousel-item style="height:421px">
          <img src="../../assets/img/bannerImg1.png">
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 推荐资源 -->
    <h5 class="mIndexTitle">推荐资源 <b @click="goOfferList">更多</b> </h5>
    <div class="mPurchase" v-for="(item,index) in demandList.slice(0,3)" :key="index">
      <h3>{{item.verietiesName}} <span>求购量：{{item.total}}{{item.unit}}</span><span>{{item.endTime}}</span></h3>
      <ul>
        <li><b>规则</b></li><li><b>产地</b></li><li><b>交货地点</b></li><li><b>规格</b></li>
        <li>{{item.skuName}}</li><li>不限</li><li>不限</li><li>{{item.requirements}}</li>
      </ul>
      <p class="mPurchaseText"><img src="../../assets/img/mIndexGroup.png" alt=""><span>报价{{index+2}}人</span> <u>发布时间：2022/02/26 14:03</u><button @click="goOfferDetails(item.id)">立即报价</button></p>
    </div>
    <h5 class="mIndexTitle">药材交易动态 </h5>
    <div class="mIndexBuy">
      <div class="mIndexBuyMore" @click="goDynamicsList">更多</div>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="市场价格" name="first">
          <table class="jgTable">
            <thead>
              <td v-for="(item,tdIndex) in jgList" :class="jgActiveClass == tdIndex ? 'tableActive':''" :key="item.id"  @click="changeJG(tdIndex,item.id)"><a>{{item.name}}</a></td>
            </thead>
            <tr><td><u>品名</u></td><td><u>规格</u></td><td><u>价格</u></td><td><u>走势</u></td></tr>
            <tr v-for="item in dynamicsList.slice(0,6)" :key="item.id"><td>{{item.ycnam}}</td><td>{{item.guige}}</td><td><b>￥{{item.pri}}</b></td><td>{{item.zoushi}}</td></tr>
          </table>
        </el-tab-pane>
        <el-tab-pane label="涨跌幅榜" name="second">
          <table class="zftable">
            <thead>
              <td v-for="(item,zfTdIndex) in dynamicsTimeList" :key="zfTdIndex" :class="zfActiveClass == zfTdIndex ? 'tableActive':''" @click="changeZF(item.id,zfTdIndex)"><a >{{item.name}}</a></td>
            </thead>
            <tr><td><u>品名</u></td><td><u>规格</u></td><td><u>产地</u></td><td><u>价格</u></td><td><u>涨幅</u></td></tr>
            <tr v-for="item in dynamicsList.slice(0,6)" :key="item.id"><td>{{item.ycnam}}</td><td>{{item.guige}}</td><td>{{item.chandi}}</td><td><b>￥{{item.pri}}</b></td><td>{{item.zoushi}}</td></tr>
          </table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <h5 class="mIndexTitle">新闻资讯 <b @click="goNewslist">更多</b></h5>
    <ul class="mIndexInformation">
      <li v-for="item in newsList.slice(0,6)" :key="item.id" @click="goNewsDetails(item.id)"><span>•</span>{{item.articleTitle}}<b>{{item.createTime}}</b></li>
    </ul>
    <h5 class="mIndexTitle">自营产品 <b @click="goProductList">更多</b></h5>
    <ul class="mIndexPro">
      <li v-for="item in goodsList.slice(0,4)" :key="item.id"  @click="goProductDetails(item.id)">
        <img :src="item.images" />
        <p>{{item.goodName}}&nbsp;{{item.chandi}}</p>
        <p><span>价格电议</span> </p>
      </li>
    </ul>
    <h5 class="mIndexTitle">合作伙伴</h5>
    <!-- <ul class="mIndexPartner">
      <li v-for="itemqq in aboutImgList" :key="itemqq.id"><img :src="itemqq.aboutImgurl" /></li>
    </ul> -->
     <div id="demo" class="qimo8">
      <div class="qimo">
        <div id="demo1" ref="demo1">
          <ul>
            <li v-for="itemqq in aboutImgList" :key="itemqq.id"><img :src="itemqq.aboutImgurl" /></li>
          </ul>
        </div>
      <div id="demo2"></div>
      </div>
    </div>
    <ul class="mfoot" style="margin-bottom:70px">
      <li>电话：0558-5858131</li>
      <li>地址：亳州市谯城区亳芜现代产业园区希夷大道与月季路交叉口</li>
      <li>安徽广盛堂中药饮片有限公司 版权所有 免责声明 皖ICP备18026442号</li>
      <li>皖公网安备 3416020200060号</li>

    </ul>
    <Login ref="login"></Login>
    <Register ref="register"></Register>
  </div>
</template>
<script>
import Login from '../mobile/mLogin'
import Register from '../mobile/mRegister'
export default {
  components: {
    Login,
    Register,
  },
  data() {
    return {
      showHeaderIcon:true,
      showHeaderIcon2:false,
      showMenuDiv:false,
      activeClass: -1, 	// 0为默认选择第一个，-1为不选择
      activeName:'first',
      jgActiveClass:0,
      zfActiveClass:0,
      tdIndex:0,
      zfTdIndex:0,
      jgList:[
        {id:"1",name:'亳州药市'},
        {id:"2",name:'安国药市'},
        {id:"3",name:'玉林药市'},
        {id:"4",name:'荷花池药市'}
      ],
      showLogin:true,
      showAfterLogin:false,
      demandList:[],//资源
      grouplist:[],//分类
      twoGrouplist:[],//二级分类
      bannerlist:[],//轮播图片
      articleList:[],//公告
      newsList:[],//新闻
      dynamicsList:[],
      loginDialog: false,
      registerDialog:false,
      checked:false,
      showProduct:false,
      goodsList:[],
      aboutImgList:[
        {id:"000",aboutImgurl:require('../../assets/img/partner6.png')},
        {id:"001",aboutImgurl:require('../../assets/img/partner7.png')},
        {id:"002",aboutImgurl:require('../../assets/img/partner8.png')},

        // {id:"000",aboutImgurl:require('../../assets/img/partner1.png')},
        // {id:"001",aboutImgurl:require('../../assets/img/partner2.png')},
        // {id:"002",aboutImgurl:require('../../assets/img/partner3.png')},
        // {id:"003",aboutImgurl:require('../../assets/img/partner4.png')},
        // {id:"004",aboutImgurl:require('../../assets/img/partner5.png')}
      ],
      onA:'',
      dynamicsTimeList:[
        {id:'yesterday',name:'日'},
        {id:'zhouduibi',name:'周'},
        {id:'yueduibi',name:'月'},
        {id:'jiduibi',name:'季'},
        {id:'nianduibi',name:'年'},
      ],
      timer:null,
      menuActiveClass:0,
      menuList:[
        // {go:'mIndex',name:'首页'},
        // {go:"mClassList",name:'产品分类'},
        // {go:'mOfferList',name:'推荐资源'},
        // {go:'mDynamicsList',name:'交易动态'},
        // {go:'mNewsList',name:'药材资讯'},
        // {go:'mProductList',name:'自营产品'}
        {go:'mIndex',name:'首页',Imgurl:require('../../assets/img/mFootTab1.png')},
        {go:"mClassList",name:'分类',Imgurl:require('../../assets/img/mFootTab2.png')},
        {go:'mDynamicsList',name:'动态',Imgurl:require('../../assets/img/mFootTab3.png')},
        {go:'mNewsList',name:'资讯',Imgurl:require('../../assets/img/mFootTab4.png')},
        {go:'mProductList',name:'自营',Imgurl:require('../../assets/img/mFootTab5.png')}
      ],
    }
  },
  mounted() {
    if(this.$cookie.get('account') == null || this.$cookie.get('account') == ''){
      this.showLogin = true
      this.showAfterLogin = false
    }else{
      this.showLogin = false
      this.showAfterLogin = true
    }
    this.getDemandInfoList();
    this.getGoodsList();
    this.getGroupList();
    //this.getBannerImgList();
    this.getArticleList();
    this.getNewsList();
    this.getDynamicsList();
    this.timer = setInterval(() => {
      var that = this
      that.Marquee();
    }, 20)

    //setInterval(this.Marquee, 20);
  },
  methods: {
    search(){
      this.$fetch('getOfferList',{keyWord:this.input2,pageNo:this.currentPage,pageSize:this.pageSize}).then(res => {
        this.demandList = res.result.records;
        this.totalNum = res.result.total;
      })
      this.getQueryCount()
    },
    showMenu(){
      this.showMenuDiv = true;
      document.body.style['overflow'] = 'hidden';
      this.showHeaderIcon = false;
      this.showHeaderIcon2 = true;
    },
    closeMenu(){
      this.showMenuDiv = false;
      document.body.style['overflow-y'] = 'scroll';
      this.showHeaderIcon = true;
      this.showHeaderIcon2 = false;
    },
    goMenu(go,index){
      this.$cookie.set('menuA',index)
      this.menuActiveClass = index;
      document.body.style['overflow'] = 'auto';
      this.$router.push(go)
    },
    goLogin(){
      this.$refs.login.toLogin();
    },
    goRegister(){
      this.$refs.register.toRegister();
    },
    goIndex(){
      this.$router.push({name:'mIndex'})
    },
    Marquee () {
      var demo = document.getElementById('demo')
      var demo1 = document.getElementById('demo1')
      var demo2 = document.getElementById('demo2')
      demo2.innerHTML = document.getElementById('demo1').innerHTML
      if (demo.scrollLeft - demo2.offsetWidth >= 0) {
        demo.scrollLeft -= demo1.offsetWidth
      } else {
        demo.scrollLeft++
      }
    },
    //资源列表
    getDemandInfoList(){
      this.$fetch('getDemandInfoList').then(res => {

        this.demandList = res.result.records;
        console.log('resgetDemandInfoList',this.demandList)
      })
    },
    //产品
    getGoodsList(){
      this.$fetch('getGoodsList',{recommend: 'Y',pageNo:1,pageSize:10}).then(res => {
        this.goodsList = res.result.records;
      })
    },
    //分类
    getGroupList(){
      this.$fetch('getGroupList').then(res => {
        this.grouplist = res.result;
      })
    },
    //轮播图片
    getBannerImgList() {
      this.$fetch('getBannerImgList').then(res => {
        this.bannerlist = res.result.records;
      })
    },
    //公告
    getArticleList() {
      this.$fetch('getArticleList',{articleType: "1",pageNo: 1,pageSize: 10}).then(res => {
        this.articleList = res.result.records;
      })
    },
    //新闻
    getNewsList() {
      this.$fetch('getArticleList',{articleType: "2",pageNo: 1,pageSize: 10}).then(res => {
        this.newsList = res.result.records;
      })
    },
    // 药材交易动态 切换
    handleClick(tab, event) {
      console.log('111',tab.name, event);
    },
    // 药材交易动态
    getDynamicsList(){
      this.$fetch('getDynamicsList',{market:1}).then(res => {
        this.dynamicsList = res.result.records;
      })
    },
    //市场价格 切换
    changeJG(tdIndex,id){
      this.jgActiveClass = tdIndex;
      this.$fetch('getDynamicsList',{market:id}).then(res => {
        this.dynamicsList = res.result.records;
      })
    },
    //点涨幅榜 切换
    changeZF(id,index){
      this.zfActiveClass = index;
      this.$fetch('getDynamicsList',{paramName:id}).then(res => {
        this.dynamicsList = res.result.records;
      })
    },
    goLogin(){
      this.$refs.login.toLogin();
    },
    goRegister(){
      this.$refs.register.toRegister();
    },
    goIndex(){
      this.$router.push({name:'Index'})
    },
    goProductList(id){console.log(id != '',id != null);
      // if(id != '' || id != null){

      //   this.$router.push({name:'mProductList',query: {groupId:id}})
      // }else{
      //   this.$router.push('/mProductList')
      // }
      this.$router.push('/mProductList')
    },
    goNewslist(){
      this.$router.push('/mNewsList')
    },
    goOfferList(){
      this.$router.push('/mOfferList')
    },
    goDynamicsList(){
      if( this.activeName== 'first '){
        this.$router.push('/mDynamicsList')
      }else{
        // this.$router.push('/UpanddownList')
        this.$router.push('/mDynamicsList')
      }
    },
    //跳转产品详情
    goProductDetails(id){
      this.$router.push({name:'mProductDetails',query: {id:id}})
    },
    goNewsDetails(id){
      this.$router.push({name:'mNewsDetails',query: {id:id}})
    },
    goOfferDetails(id){
      this.$router.push({name:'mOfferDetails',query: {id:id}})
    }
  },
  beforeDestroy () {
    clearInterval(this.timer);
    this.timer = null
  }
}
</script>

<style>
@import "../../assets/css/mStyle.css";
/* 菜单 */
.index1{width:100%;height:494px;overflow: hidden;}
.index1Box{width:1240px;margin:20px auto;}
.index1Left{width:180px;height:460px;float:left;position:relative;}
.index1Left h4{width:100%;height:46px;line-height:46px;background: #CDA35A;color:#fff;font-size:16px;}
.index1Left h4 img{width:23px;height:16px;margin:0px 6px 0 0;vertical-align: middle;}
.index1Left ul{width:100%;height:430px;background: #fff;display: block;overflow: hidden;}
.index1Left ul li{list-style:none;text-align:left;border-bottom:1px solid #f1f1f1;border-left:2px solid #fff;}
.index1Left ul li,.index1LeftProduct h6{width:calc(100% - 10px);height:32px;line-height:32px;font-size:14px;font-weight:100;color:#363636;padding-left:10px;text-align:left;}
.index1Left ul li img{height:16px;vertical-align:middle;margin-right:10px;}
.index1Left ul li p,.index1LeftProduct p{width:calc(100% - 10px);height:40px;line-height: 20px;font-size:12px;overflow: hidden;color:#b9b9b9;padding-left:10px;margin-bottom:10px;text-align:left;}
.index1Left ul li p a{width: 100%;height:40px;line-height: 20px;font-size:12px;overflow: hidden;color:#b9b9b9;}
.index1Left ul .indexProductActive{background:rgba(205,163,90,.4);border-left:2px solid #CDA35A;}
.index1Left ul .indexProductActive a{color:#CDA35A;letter-spacing:1px;}
.index1Left ul .indexProductActive1{background:#fff;border-left:2px solid #fff;}
.index1Left ul .indexProductActive1 a{color:#b9b9b9;letter-spacing:1px;}
.index1Right{width:1060px;float:left;}
/* 导航 */
.index1RightNav{width:100%;height:46px;line-height:46px;background: #fff;}
.index1RightNav li{width:20%;height:46px;line-height:46px;float:left;list-style:none;color:#363636;font-size:16px;font-weight:bold;letter-spacing:1px;cursor: pointer;display: block;}
.index1RightNav li.navActive{color: #CDA35A;}

/* 二级产品分类 */
.index1LeftProduct{width:800px;height:430px;background: #fff;position:absolute;left:180px;top:46px;z-index:999;}
.index1LeftProduct div{width:100%;max-height:136px;overflow: hidden;}
.index1LeftProduct h5{width: 100%;height:36px;line-height:36px;text-align:left;border-bottom:1px solid #eee;}
.index1LeftProduct h5 b{font-size:16px;padding:0 10px;cursor: pointer;}
.index1LeftProduct p{width:calc(100% - 10px);height:auto;line-height:24px;font-size:12px;overflow:hidden;color:#b9b9b9;padding-left:10px;margin-bottom:10px;text-align:left;}
.index1LeftProduct p a{letter-spacing:1px;font-size:12px;}
.index1LeftProduct p a:hover{color:#CDA35A;}
.index1LeftProductP{color:#CDA35A}
/* 大图轮播 */
.index1RightBanner{width:calc(100% - 260px);height:430px;float:left;}
.el-carousel.el-carousel--horizontal,.el-carousel__container{height:430px;}
.el-carousel__item.is-active.is-animating{height:430px !important;}
/*右侧登录 */
.index1RightLogin{width:260px;height:430px;float:left;background: #fff;}
.index1RightLogin h5{width:100%;height:34px;margin:20px;}
.index1RightLogin h5 button{width:94px;height:34px;line-height:34px;border:1px solid #CDA35A;border-radius:3px;float:left;margin:0 0 20px 20px;background: #fff;color:#CDA35A;font-size: 14px;letter-spacing:1px;}
.index1RightLogin h5 button:first-child{background:#CDA35A;color:#fff;}
/* 登录后 */
.index1RightLogin .afterLogin{vertical-align: middle;color:#666;font-size:14px;text-align: left;}
.index1RightLogin .afterLogin img{width:40px;height:40px;vertical-align: middle;margin-right:10px}
.index1RightLogin .el-tabs--border-card{box-shadow:none;border:none;border-top: 1px solid #f1f1f1;}
.index1RightLogin .el-tabs--border-card>.el-tabs__header{border:none;}
.index1RightLogin .el-tabs__nav{width:100%;}
.index1RightLogin .el-tabs--border-card>.el-tabs__header .el-tabs__item{width:50%;background:#f2f2f2;color:#4b4b4b !important;outline:none;border:none;}
.index1RightLogin .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{background:#fff;border:none}
.index1RightLogin .el-tabs--border-card>.el-tabs__content{padding:15px 15px 0 15px;}
.index1LoginUl {width: 100%;height:80px;border-bottom:1px solid #f1f1f1}
.index1LoginUl li{width: 33.33%;height:80px;float:left;list-style:none;cursor: pointer}
.index1LoginUl li img{height:32px;text-align: center;}
.index1LoginUl li p{width: 100%;height:30px;line-height:30px;font-size:14px;}
.el-tabs__item:hover{color:#CDA35A;}
/* 登录公告 */
.index1RightLogin h6{width:100%;height:40px;line-height:40px;overflow: hidden;vertical-align: middle;text-align: left;padding-left: 20px;font-size:16px;letter-spacing: 1px;}
.index1RightLogin h6 img{width: 20px;vertical-align: middle;margin-right: 5px;}
.index1LoginGG{width:100%;height:145px;overflow: hidden;}
.index1LoginGG li{width:calc(100% - 40px);text-align: left;height:28px;line-height:28px;padding-left: 20px;list-style:none;color:#666;font-size:12px;}
.index1LoginGG li span{margin-right:3px;}
.index1LoginGG li b{float:right;font-size:12px;font-weight: 100;}
.index1LoginGG li:hover,.el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover{color:#CDA35A;}

.seamless-warp{width:100%;height:170px;overflow: hidden;}
</style>



// WEBPACK FOOTER //
// src/components/mobile/mIndex.vue